var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 372.44 472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.09,0H31.34A31.38,31.38,0,0,0,0,31.34V440.66A31.38,31.38,0,0,0,31.34,472H341.09a31.38,31.38,0,0,0,31.35-31.34V31.34A31.38,31.38,0,0,0,341.09,0Zm-94.8,18.44V56a10.39,10.39,0,0,1-10.37,10.38H136.51A10.39,10.39,0,0,1,126.14,56V18.44ZM182.72,435.12h85.55a9.19,9.19,0,0,0,6.51-2.7l58.08-58.07a9.23,9.23,0,0,0,2.7-6.52V64.53a27.68,27.68,0,0,0-27.65-27.65H264.73V18.44h76.36A12.92,12.92,0,0,1,354,31.34V440.66a12.92,12.92,0,0,1-12.91,12.9H31.34a12.92,12.92,0,0,1-12.9-12.9V31.34a12.92,12.92,0,0,1,12.9-12.9h76.37V36.88H64.53A27.68,27.68,0,0,0,36.88,64.53V407.47a27.68,27.68,0,0,0,27.65,27.65H182.72ZM109,416.69H64.53a9.24,9.24,0,0,1-9.22-9.22V64.53a9.24,9.24,0,0,1,9.22-9.22h43.18V56a28.84,28.84,0,0,0,28.8,28.81h99.41A28.84,28.84,0,0,0,264.73,56v-.69h43.18a9.23,9.23,0,0,1,9.21,9.22V358.61H286.7a27.69,27.69,0,0,0-27.65,27.66v30.42H109Zm195.12-39.64-26.61,26.6V386.27a9.23,9.23,0,0,1,9.22-9.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.53,211,99,239.58,90.41,231a9.22,9.22,0,0,0-13,13l15.08,15.09a9.22,9.22,0,0,0,13,0l35.08-35.08a9.22,9.22,0,0,0-13-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.78,261.72h46.81a9.22,9.22,0,1,0,0-18.44H176.78a9.22,9.22,0,1,0,0,18.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.78,224.84H270.4a9.22,9.22,0,1,0,0-18.43H176.78a9.22,9.22,0,1,0,0,18.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.57,296.76a9.22,9.22,0,0,0-13,0L99,325.31l-8.56-8.56a9.22,9.22,0,1,0-13,13l15.08,15.08a9.22,9.22,0,0,0,13,0l35.08-35.08A9.21,9.21,0,0,0,140.57,296.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.59,347.45a9.22,9.22,0,1,0,0-18.43H176.78a9.22,9.22,0,1,0,0,18.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.78,310.58H270.4a9.22,9.22,0,0,0,0-18.44H176.78a9.22,9.22,0,0,0,0,18.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.45,172.33a9.22,9.22,0,0,0,13,0l35.08-35.08a9.22,9.22,0,0,0-13-13L99,152.77l-8.56-8.56a9.22,9.22,0,0,0-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.78,174.91h46.81a9.22,9.22,0,1,0,0-18.43H176.78a9.22,9.22,0,1,0,0,18.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.78,138H270.4a9.22,9.22,0,1,0,0-18.44H176.78a9.22,9.22,0,0,0,0,18.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.dc310960c8f17cce9f06fcb154f37b43.svg";
export { ForwardRef as ReactComponent };